import { createAxiosPlugin } from '../../shared/axios.js';
/**
 * js/axios
 */
export const jsAxios = createAxiosPlugin('js');
